import React from 'react'
import Hero from '../hero'
import Features from '../features'
import FeaturesBlocks from '../features-blocks'
import MovingBand from '../movingBand'
import Venue from '../Venue'


const Home = () => {
  return (
    <>

      <Hero />
      <Features />
      <FeaturesBlocks />
      <Venue />
      <MovingBand/> 
    </>
  )
}

export default Home